import { render, staticRenderFns } from "./HomeHeroCopy.vue?vue&type=template&id=8e9298f8&scoped=true&"
import script from "./HomeHeroCopy.vue?vue&type=script&lang=js&"
export * from "./HomeHeroCopy.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeroCopy.vue?vue&type=style&index=0&id=8e9298f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9298f8",
  null
  
)

export default component.exports